import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';

import * as DeleteDestinationActions from '../actions/delete-destination.actions';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DestinationsService } from '../../../services/api/destinations/destinations.service';
import * as DestinationsActions from '../actions/destinations.actions';
import {UUID} from '../../../shared/types/uuid.type';
import {Destination} from '../../../services/api/destinations/destination.model';



@Injectable()
export class DeleteDestinationEffects {

  // noinspection JSUnusedGlobalSymbols
  deleteDestination$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DeleteDestinationActions.deleteDestination),
      concatMap((payload: {id: UUID}) =>
        this.destinationsService.delete(payload.id).pipe(
          map((data: Destination) => DeleteDestinationActions.deleteDestinationSuccess({ data })),
          catchError((error: any) => of(DeleteDestinationActions.deleteDestinationFailure({ error }))))
      )
    );
  });

  // noinspection JSUnusedGlobalSymbols
  deleteDestinationSuccess$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DeleteDestinationActions.deleteDestinationSuccess),
      tap(() => this.snackBar.open('Destination successfully deleted', 'Success', {duration: 3000})),
      map(() => DestinationsActions.loadDestinations()),
    );
  });



  constructor(
    private readonly actions$: Actions,
    private readonly snackBar: MatSnackBar,
    private readonly destinationsService: DestinationsService
  ) {}

}
